const cdn77 = require("cdn77");
function encryption(api, url, token) {
  if (token) {
    var now = Math.floor(new Date() / 1000);
    var exampleSigner = cdn77(api, token, true);
    return exampleSigner(url, now + 15);
  } else {
    return (api != '' && api != '/' ? "https://" + api : '') + url;
  }
}
export default encryption;



// WEBPACK FOOTER //
// ./src/helpers/encryption.js